module.exports = __webpack_public_path__ + "72bf33aac8c4355980c656c8581e438a.MP3";